"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

/**
 * Views for the delegate ("on behalf of") read tools — who the user is a
 * delegate for, and those delegators' reports. Merged into
 * `concurToolRegistry` by the registry wiring.
 */
export const concurDelegateToolRegistry = {
  concurListDelegators: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./delegate-views").then(({ ConcurListDelegatorsToolView }) => ({
        default: ConcurListDelegatorsToolView,
      }))
    ),
  },
  concurListDelegatorReports: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./delegate-views").then(
        ({ ConcurListDelegatorReportsToolView }) => ({
          default: ConcurListDelegatorReportsToolView,
        })
      )
    ),
  },
  concurGetDelegatorReport: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./delegate-views").then(
        ({ ConcurGetDelegatorReportToolView }) => ({
          default: ConcurGetDelegatorReportToolView,
        })
      )
    ),
  },
} satisfies ToolUIRegistry;
